export default "__VITE_ASSET__DIfIjdFP__"